export var svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    "aria-hidden": true
};
